import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
import styles from '../../services/styles';
import logo from '../../assets/logo.png'
import { Spin } from 'antd';

const { COLORS } = styles

const SplashScreen = () => {

    const {
        mobile_mode
    } = useContext(GeneralContext)

    const navigate = useNavigate()

    // useEffect(() => {
    //     setTimeout(handleOnValidateSession, 1000);  
    // })

    // const handleOnValidateSession = async () => {
    //     try {
    //         const token = localStorage.getItem('token')
    //         if (!token) {
    //             setLoggedUser(false)
    //             return
    //         }

    //         // const res = await api.auth.validateUserSession()
    //         // const user = res.data

    //         // if (!user) {
    //         //     setLoggedUser(false)
    //         //     return
    //         // }

    //         api.auth.setAuthorizationToken(token)
    //         setLoggedUser(true)

    //     } catch (error) {
    //         console.log('Erro ao validar sessão: ', error)
    //         setLoggedUser(false)
    //     }
    // }

    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            gap: 15,
            backgroundColor: 'white', // COLORS.GRAY[50],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
        }}>
            <div style={{ height: mobile_mode ? 200 : 350, aspectRatio: 1 }}>
                <img width={'100%'} height={'70%'} src={logo} />
            </div>

            <Spin size="default" />

            <span style={{ marginTop: 10, color: COLORS.RED[800], fontSize: mobile_mode ? 14 : 16 }}>Desenvolvido por <span style={{ fontWeight: 'bold' }}> Solve Light</span> </span>
        </div>
    );
};

export default SplashScreen;